
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexFaOBicsv2imDJZM1wClAGeYNmlP_45NvUW5gtrVbnIkxoMeta } from "/codebuild/output/src3602392869/src/pages/index.vue?macro=true";
import { default as indexltBPWpkfUJn8rQG1rQmjOSnW1MqUO4H73pc_45HaYPyhIMeta } from "/codebuild/output/src3602392869/src/pages/login/index.vue?macro=true";
import { default as indexhY_tQ1F_45X52TZS5U92pGCO0iLs4KWEdG68vxt9AQpokMeta } from "/codebuild/output/src3602392869/src/pages/software/index.vue?macro=true";
import { default as index6XYsDKUcbWRXrkZgKY1krEpq3jkK1Fn9oHmZj6J72vcMeta } from "/codebuild/output/src3602392869/src/pages/trackers/index.vue?macro=true";
import { default as indexo1Rr_nmFS8OCcxg8PhiuljtEWcRkbmpertHQknGxt1YMeta } from "/codebuild/output/src3602392869/src/pages/templates/index.vue?macro=true";
import { default as createjebrY0fLkPfueGMpxtN01y1aRdgmqpJgIA_U06DkuOgMeta } from "/codebuild/output/src3602392869/src/pages/trackers/create.vue?macro=true";
import { default as createOo3cw6C9KT9tgt_jKwdnkOC_pcBZHDCK7fMd8vfmSTkMeta } from "/codebuild/output/src3602392869/src/pages/templates/create.vue?macro=true";
import { default as indexdxUR4KhZlFgPV7e9Ff_wnHGanoojS_GBdeVXbxfiIPYMeta } from "/codebuild/output/src3602392869/src/pages/tagging-docs/index.vue?macro=true";
import { default as editxoNvgAt9eRmJGSCS1Xr4QLaAIUA5g18tDSaJLsAg7CEMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93GyDzfp8sqOEsQGI65VlHXdVqBWXtDGH0RHna2MbOMDIMeta } from "/codebuild/output/src3602392869/src/pages/login/token/[token].vue?macro=true";
import { default as editH9edf7pzHvbZnoduZfrdjjm8x3aPO4EsUJ_456MeNciIkMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexS_VZGf9g9H2o20qLagbJmWWpY1Qd7l0AAh_vayBCe5sMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/index.vue?macro=true";
import { default as index9VqZMVlribjIvC_mIUKE4BXwnrBPuD6jHKpKJYt8I94Meta } from "/codebuild/output/src3602392869/src/pages/plan-management/index.vue?macro=true";
import { default as indexlZRJeMV1oAZI_EmifoyiqwiGGPNuqJrp746KGffT3F4Meta } from "/codebuild/output/src3602392869/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexz8cy_xo_E4jmaDw1gDYzjXH8M67Jfr2Y0iNVWA_45n458Meta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexsInENOa87lP6uVsFjobJBy2C5s_45ubX7oOZjar1MSvaUMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexR4sT0UMMxLpVCu82PVpDC_oIxSnHVvfzP47ClY5k2YcMeta } from "/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createRSF6cleIkaa6_JcgQcAv1z6RamREMbX_n_45LsU1nSzAsMeta } from "/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editL3ASzyqOBeJ7QElsgJJYR_c_458ApvLRJVOdS1c05MXTsMeta } from "/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsPd0VAskc7Cl2H5Jft7OHvbFhyGlv_45Kceg2TdhNr0opYMeta } from "/codebuild/output/src3602392869/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexMjmZiJDk6W3j83dPnRi_sUUc2L8i8pzhydSf90SrTuEMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createOMaXMHzehceMBwM0RSs50buKStQYJHGHqGl_ZTx52soMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groups2NoEVCaQXdO5wsHC8TqE8y6ZSbRGjyWpiT871BaKeEwMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createSSGNya_45vZyEJoq3gNCfprAvQPm_6T3D0sca4nXkkwvQMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexc7RpNJiEvPhIA_45rpXP5b1lkO4r2savKGn6J3Z6lEH1EMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexBhHMEfaDYGgjVpUWxxCEycwc7xtO1P_Bb3KeZqi7q7cMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createAMbFA5aNMfxPM0p3_45X5PorEvrmdLBmfhiGAlpN5GVdcMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backend2YcdAM1SsPHXzP_cTMacatLBa4wmfcVZfaxSsKbS68gMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createUcWsrkx66hB2MEQzRFFY9GAK0JcLqfCsGdkVLyQ0zw8Meta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendJ_533xgERlwjKQ13A657H5d42xpyYj5Oxa7I54zIjUAMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePagemRxYPWw53_cbriV2vA0yYLrjHxmo8u9Jb8hm0n58imMMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexjEc2j9_0_AVeMZtOdaQCB1Czg6wQZ3zt1vZ9T9AWhR4Meta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexkJxhg8Mwn4vZK0kF7CnNCzXlKRIfFIfa4QGCuuYMZ7wMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipHAXbcU1oTrKgIESoOqJVGFv_453KGKBO0Vk9lSVjNR3aoMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as indexqTHVbn_45qY8ZPNSEjS1AlFARUxn44cDpwLrO5RSgarjAMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexmWgraXumM16437Bf1mS6TYJ7opHh1no7q4Q0ebESVnkMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendX5BZbv68MJ9lkWbvE9nIf_45g_45gtVEX3oDCoTBPVMMSCQMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2xnqsSgvVJNbs0aZaiEYv_45nTsCnB_ehezbwBPNrLl_J4Meta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as edit6ifIz1B5iplEoZEbj3eqq7nWRsuAHG5T3rhPG5xXto4Meta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editUEM8RMZGuIuNNevCU1mY7xIds6ZsootXwqRUe1pn01gMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45components_45JMH_45hv1rNvnSuKNAgiWSUGLd10T4cq_XSwxCPlDb5sMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesz_GLPtTSxJ30A1Dr_45qBQQDNLCVwq1IFPS1_45Fv2oUC0EMeta } from "/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexb7DMo7zaXqz6iELBk_45MtXd2Fj_45AJ2RLlxbkK1P3vHkgMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexq0629uYLQpYkaM1qyKqWNu58Fnr6LxO9gwHrEhSER8gMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as create7bc_455MW_45yQBQwCpGWmi4fVChyL_45w1ldkT0_8y1T0g4kMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createZHk0WTgVvJhLRqGdAFhkjnsi5twRb7aK0THVC1_Y5IgMeta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as edit4k8FnSuAwH50cqfLFd11MOx130K7pE8pdG0IlMimGoQMeta } from "/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as edituusVeg5phK9B7oWMkmBqxqI0HX7L1_2M1VJV0wmxFF8Meta } from "/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3602392869/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src3602392869/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src3602392869/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src3602392869/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src3602392869/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src3602392869/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src3602392869/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsPd0VAskc7Cl2H5Jft7OHvbFhyGlv_45Kceg2TdhNr0opYMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src3602392869/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src3602392869/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3602392869/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]